module.exports = __webpack_public_path__ + "img/gal-1.9ea8bbcf.jpg";